import React, { Component } from 'react';
//import withRouter from '../../Helpers/withRouter';
import { useParams, useNavigate } from "react-router-dom";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import axios from 'axios';
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";

const withRouter = (WrappedComponent) => (props) => {
  const params = useParams();
  const navigate = useNavigate();
  // etc... other react-router-dom v6 hooks

  return (
	<WrappedComponent
	  {...props}
	  params={params}
	  navigate={navigate}
	  // etc...
	/>
  );
};
	
class Add extends Component {

	constructor(props)
	{
		// CheckAuth();
		super();	
		this.state = {
			title:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
			icon_name: '',
			icon_preview: '',
			icon: '',
			icon_fileExtension: '',
			enableuploadgalley: false,
			imagelist: [],
			selectedImage: null,
			unlinkImage: null,
			imageUsageMessage: '',
			showUnlinkConfirm: false,
			showUsageWarning: false,
			jsonimg_preview: "",
            jsonimg_name: "",
			imagejson: "",
            imagejson_fileExtension: "",
			enablejsonuploadgalley:false,
			selectedjsonImage: null,
			unlinkjsonImage: null,
			imagejsonlist: [],
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);

    }

	componentDidMount() {
		this.loadGalleryImages();
		this.loadGalleryjsonImages();
	}

	loadGalleryImages = () => {
		axios.get(apiUrl + "InsuranceCategory/getimagelist").then(res => {
			if (res.data.status === 'success') {
				this.setState({ imagelist: res.data.imagelist || [] });
			}
		});
	};

	loadGalleryjsonImages = () => {
		axios.get(apiUrl + "InsuranceCategory/getimagejsonlist").then(res => {
			if (res.data.status === 'success') {
				this.setState({ imagejsonlist: res.data.imagelist || [] });
			}
		});
	};

	handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}
	};

   handleInputChange(event) {
      const {name, value} = event.target;
      this.setState({
          [name]: value
        });
  }

  onChangeHandler = (event) => {
	let reader = new FileReader();
	const file = event.target.files[0];
	const extension = file.name.split(".").pop();
	reader.onloadend = () => {
	  this.setState({
		icon_name: file.name,
		icon_preview: reader.result,
		icon: file,
		icon_fileExtension: extension,
	  });
	};
	reader.readAsDataURL(file);
  };

  onChangejsonHandler = (event) => {
	let reader = new FileReader();
	const file = event.target.files[0];
	const extension = file.name.split(".").pop();
	
	reader.onloadend = () => {
	  this.setState({
		jsonimg_name: file.name,
		jsonimg_preview: reader.result,
		imagejson: file,
		imagejson_fileExtension: extension,
		enablejsonuploadgalley: false
	  });
	};
	reader.readAsDataURL(file);
  };

  selectGalleryImage = (image) => {
	this.setState({ selectedImage: image, enableuploadgalley: false }, () => {
	  fetch(image.url)
		.then(res => res.blob())
		.then(blob => {
		  const file = new File([blob], image.name, { type: blob.type });
		  const reader = new FileReader();
		  reader.onloadend = () => {
			this.setState({
			  icon: file,
			  icon_name: image.name,
			  icon_preview: reader.result,
			  icon_fileExtension: image.name.split('.').pop()
			});
		  };
		  reader.readAsDataURL(blob);
		});
	});
  };

   selectjsonGalleryImage = (image) => {
	this.setState({ selectedjsonImage: image, enablejsonuploadgalley: false }, () => {
	  fetch(image.url)
		.then(res => res.blob())
		.then(blob => {
		  const file = new File([blob], image.name, { type: blob.type });
		  const reader = new FileReader();
		  reader.onloadend = () => {
			this.setState({
			  imagejson: file,
			  jsonimg_name: image.name,
			  jsonimg_preview: reader.result,
			  imagejson_fileExtension: image.name.split('.').pop()
			});
		  };
		  reader.readAsDataURL(blob);
		});
	});
  };

  renderGalleryImages = () => {
	const imageArr = this.state.imagelist;
	if (!imageArr || imageArr.length === 0) {
	  return <li>No images found</li>;
	}
	return imageArr.map((image, index) => (
	  <li className="gallery-multiselect-item position-relative" key={index}>
		{image.used === 'in_use' && (
		  <span className="gallery-in-use-label position-absolute" style={{top: 5, left: 5, background: 'rgba(255, 0, 0, 0.7)', color: '#fff', padding: '2px 6px', borderRadius: '3px', fontSize: '10px', zIndex: 5}}>
			In Use
		  </span>
		)}
		<span
		  className="gallery-unlink-btn close-text position-absolute"
		  onClick={(e) => this.handleUnlinkClick(image, e)}
		  style={{pointerEvents: image.inuse === 'yes' ? 'none' : 'auto', opacity: image.inuse === 'yes' ? 0.5 : 1}}
		>
		  ×
		</span>
		<input
		  type="checkbox"
		  className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer"
		  value={image.name}
		  checked={this.state.selectedImage?.name === image.name}
		  onChange={() => this.selectGalleryImage(image)}
		  disabled={image.inuse === 'yes'}
		/>
		<img src={image.url} alt={image.name || ''} />
	  </li>
	));
  };

   handleUnlinkClick = (image, e) => {
	e.stopPropagation();
	e.preventDefault();
	axios.get(apiUrl + "InsuranceCategory/checkimageusage?imagename=" + image.name)
	  .then(res => {
		if (res.data.status === 'success' && res.data.usagecount > 0) {
		  this.setState({
			unlinkImage: image,
			imageUsageMessage: `This image is used in ${res.data.usagecount} listing(s) and cannot be unlinked.`,
			showUsageWarning: true
		  });
		} else {
		  this.setState({ unlinkImage: image, showUnlinkConfirm: true });
		}
	  });
  };
  
  renderjsonGalleryImages = () => {
	const imageArr = this.state.imagejsonlist;
	if (!imageArr || imageArr.length === 0) {
	  return <li>No images found</li>;
	}
	return imageArr.map((image, index) => (
	  <li className="gallery-multiselect-item position-relative" key={index}>
		{image.inuse === 'yes' && (
		  <span className="gallery-in-use-label position-absolute" style={{top: 5, left: 5, background: 'rgba(255, 0, 0, 0.7)', color: '#fff', padding: '2px 6px', borderRadius: '3px', fontSize: '10px', zIndex: 5}}>
			In Use
		  </span>
		)}
		<span
		  className="gallery-unlink-btn close-text position-absolute"
		  onClick={(e) => this.handlejsonUnlinkClick(image, e)}
		  style={{pointerEvents: image.used === 'in_use' ? 'none' : 'auto', opacity: image.inuse === 'yes' ? 0.5 : 1}}
		>
		  ×
		</span>
		<input
		  type="checkbox"
		  className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer"
		  value={image.name}
		  checked={this.state.selectedImage?.name === image.name}
		  onChange={() => this.selectjsonGalleryImage(image)}
		  disabled={image.inuse === 'yes'}
		/>
		<img src={image.url} alt={image.name || ''} />
	  </li>
	));
  };

  handlejsonUnlinkClick = (image, e) => {
	e.stopPropagation();
	e.preventDefault();
	axios.get(apiUrl + "InsuranceCategory/checkjsonimageusage?imagename=" + image.name)
	  .then(res => {
		if (res.data.status === 'success' && res.data.usagecount > 0) {
		  this.setState({
			unlinkjsonImage: image,
			imageUsageMessage: `This image is used in ${res.data.usagecount} listing(s) and cannot be unlinked.`,
			showUsageWarning: true
		  });
		} else {
		  this.setState({ unlinkjsonImage: image, showjsonUnlinkConfirm: true });
		}
	  });
  };

  confirmUnlink = (answer) => {
	if (answer === 'yes') {
	  const { unlinkImage } = this.state;
	  const qs = require('qs');
	  axios.post(apiUrl + "InsuranceCategory/unlinkimage", qs.stringify({ imagename: unlinkImage.name }))
		.then(res => {
		  if (res.data.status === 'success') {
			this.setState(prev => ({
			  imagelist: prev.imagelist.filter(img => img.name !== unlinkImage.name),
			  selectedImage: prev.selectedImage?.name === unlinkImage.name ? null : prev.selectedImage,
			  unlinkImage: null,
			  showUnlinkConfirm: false,
			  enableuploadgalley: false
			}));
			$('.success_message').html('<div class="status_sucess"><h3>Image successfully unlinked from folder</h3></div>');
			this.loadGalleryImages();
			setTimeout(() => {
			  $('.success_message').html('');
			}, 3000);
		  }
		});
	} else {
	  this.setState({ unlinkImage: null, showUnlinkConfirm: false });
	}
  };

    confirmUnlinkjson = (answer) => {
	if (answer === 'yes') {
	  const { unlinkjsonImage } = this.state;
	  const qs = require('qs');
	  axios.post(apiUrl + "InsuranceCategory/unlinkjsonimg", qs.stringify({ imagename: unlinkjsonImage.name }))
		.then(res => {
		  if (res.data.status === 'success') {
			this.setState(prev => ({
			  jsonimagelist: prev.imagejsonlist.filter(img => img.name !== unlinkjsonImage.name),
			  selectedImage: prev.selectedImage?.name === unlinkjsonImage.name ? null : prev.selectedImage,
			  unlinkjsonImage: null,
			  showUnlinkConfirm: false,
			  enablejsonuploadgalley: false
			}));
			$('.success_message').html('<div class="status_sucess"><h3>Image successfully unlinked from folder</h3></div>');
			this.loadGalleryjsonImages();

			setTimeout(() => {
			  $('.success_message').html('');
			}, 3000);
		  }
		});
	} else {
		  this.setState({ unlinkjsonImage: null, showjsonUnlinkConfirm: false });
	}
  };

  
  handleSubmit = () => { 
	if(this.validateForm()){
	this.setState({Loading:true});
	const formdata = this.state;
	var qs = require('qs');
	var status = '';


	if(formdata.selectedvalue === ''){
	status =formdata.selectedOption.value;
	}else{
	status = formdata.selectedvalue;
	}

	var postObject ={
		admin_id: localStorage.getItem('admin_id'),
		title : formdata.title,
		status: status
	}

	let formData = new FormData();
	for(let k in postObject) {
		formData.append(k, postObject[k]);
	}
	formData.append('icon', formdata.icon);
	formData.append('imagejson', formdata.imagejson);
	axios.post(apiUrl+"InsuranceCategory/add",formData).then(res => {
		if(res.data.status === "success"){
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						setTimeout(
						function() {
							this.props.navigate('/insurancecategory');
						}
						.bind(this),
						3000
						);
			}else{
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				
				setTimeout(
				function() {
					$('.success_message').html('');
				}
				.bind(this),
				3000
				);
				this.setState({Loading:false});
			}
		});
		
	}
  }

  validateForm() {
	const {title} = this.state;

	let errors = {};
	  let formIsValid = true;

	  if(!title){
		formIsValid = false;
		$('.errortitle').html('<span class="errorspan">Please fill the field</span>');
	}else{
		
		$('.errortitle').html('');
	}
		
	this.setState({
		errors: errors
	});
	return formIsValid;
}

confirmjsonUnlink = (answer) => {
		if (answer === 'yes') {
		  const { unlinkjsonImage } = this.state;
		  const qs = require('qs');
		  axios.post(apiUrl + "InsuranceCategory/unlinkjsonimage", qs.stringify({ imagename: unlinkjsonImage.name }))
			.then(res => {
			  if (res.data.status === 'success') {
				this.setState(prev => ({
				  imagelist: prev.imagejsonlist.filter(img => img.name !== unlinkjsonImage.name),
				  selectedImage: prev.selectedImage?.name === unlinkjsonImage.name ? null : prev.selectedImage,
				  unlinkjsonImage: null,
				  showjsonUnlinkConfirm: false,
				  enablejsonuploadgalley: false
				}));
				$('.success_message').html('<div class="status_sucess"><h3>Image successfully unlinked from folder</h3></div>');
				setTimeout(() => {
				  $('.success_message').html('');
				}, 3000);
			  }
			});
		} else {
		  this.setState({ unlinkjsonImage: null, showjsonUnlinkConfirm: false });
		}
};


  render() {
	const {selectedOption} = this.state;

	
    return (
      <div className="wrapper"> 
 
	  <Header />
      <MenuSidebar currentpage="InsuranceCategory" />  

	<div id="location-error"></div>
	<div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
                <a class="primary-btn" href="/InsuranceCategory">Back</a>
			</div>
			<div className="title">
				<h4>Add Insurance Category</h4>				
			</div>
			 <form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Title<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="title" onChange={this.handleInputChange} className="form-control" value={this.state.title}/>
					<div className="errortitle"></div>
				</div>
			</div>
                  
			<div className="form-right">

				<div className="form-group">
					<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
						   <Select
						   name="status"
						   value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
                            options={lang.common.status_option}
							isSearchable = {false}
							onChange={this.handleChange.bind(this, 'status')}
                            />
	           </div>



			</div>
			</div>

			<div className="form-row">
				<div className="form-left">
					<div className="form-group">
						<label>Icon<span class="required" style={{ color: "red" }} > * </span></label>
						<div className='d-flex gap-3 flex-wrap align-items-center'>
							<i onClick={() => this.setState({ enableuploadgalley: true })} style={{ cursor: 'pointer' }}>
								<svg width="20px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="4.76 4.76 90.49 90.48">
									<path d="m95.238 82.742v11.203c0 1.4141-1.4375 1.293-2.1523 1.293h-87.035c-1.4141 0-1.293-1.4375-1.293-2.1523l0.003907-11.203c0-1.4141 1.4375-1.293 2.1523-1.293h87.031c1.418 0 1.293 1.4336 1.293 2.1523zm-30.668-44.543v34.586h-29.141v-34.586h-16.645c-1.1523 0-1.7305-1.3906-0.91406-2.207l30.605-30.602c0.83984-0.83984 2.207-0.83984 3.0469 0l30.605 30.605c0.81641 0.81641 0.23828 2.207-0.91406 2.207z"></path>
								</svg>
							</i>
							{this.state.icon_preview ? (
								<img className="img_class" src={this.state.icon_preview} alt="Preview" />
							) : (
								<img className="img_class" src="" alt="" />
							)}
						</div>
						<div className="erroricon"></div>
					</div>
				</div>
				<div className="form-right">
				  <div className="form-group">
					{/* (jpeg,jpg,png,svg) */}
					<label>Json file upload </label>
					<div className='d-flex gap-3 flex-wrap align-items-center'>
							<i onClick={() => this.setState({ enablejsonuploadgalley: true })} style={{ cursor: 'pointer' }}>
								<svg width="20px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="4.76 4.76 90.49 90.48">
									<path d="m95.238 82.742v11.203c0 1.4141-1.4375 1.293-2.1523 1.293h-87.035c-1.4141 0-1.293-1.4375-1.293-2.1523l0.003907-11.203c0-1.4141 1.4375-1.293 2.1523-1.293h87.031c1.418 0 1.293 1.4336 1.293 2.1523zm-30.668-44.543v34.586h-29.141v-34.586h-16.645c-1.1523 0-1.7305-1.3906-0.91406-2.207l30.605-30.602c0.83984-0.83984 2.207-0.83984 3.0469 0l30.605 30.605c0.81641 0.81641 0.23828 2.207-0.91406 2.207z"></path>
								</svg>
							</i>
							{this.state.jsonimg_preview ? (
								<img className="img_class" src={this.state.jsonimg_preview} alt="Preview" />
							) : (
								<img className="img_class" src="" alt="" />
							)}
						</div>
						<div className="erroricon"></div>
				    </div> 
				</div>
			</div>		
			<div className="btn-group export">	
				<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true?
                                        <span>Adding</span>:<span>Submit</span>
                                        }
			   </button>
			 
			</div>
			</form>

			<div className={`popup-sec popup-upload-media ${this.state.enableuploadgalley ? 'active' : ''}`}>
				<div className='popup-sec-in'>
					<span className='popup-close position-absolute cursor-pointer' onClick={() => this.setState({ enableuploadgalley: false })}>X</span>
					<div className='d-flex mb-4'>
						<div className="upload-file-icon upload-file-with-label position-relative cursor-pointer lh-1 d-flex align-items-baseline gap-20px">
							<input type="file" className="position-absolute top-0 opacity-0 h-100 w-100 cursor-pointer" />
							<p className="fw-semibold m-0 me-2">Upload from device</p>
							<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
						</div>
					</div>
					<ul className="gallery-multiselct-sec d-flex gap-4 flex-wrap mt-30px">
						{this.renderGalleryImages()}
					</ul>
				</div>
			</div>

			<div className={`popup-sec popup-upload-media ${this.state.enablejsonuploadgalley ? 'active' : ''}`}>
				<div className='popup-sec-in'>
					<span className='popup-close position-absolute cursor-pointer' onClick={() => this.setState({ enablejsonuploadgalley: false })}>X</span>
					<div className='d-flex mb-4'>
						<div className="upload-file-icon upload-file-with-label position-relative cursor-pointer lh-1 d-flex align-items-baseline gap-20px">
							<input type="file" className="position-absolute top-0 opacity-0 h-100 w-100 cursor-pointer" />
							<p className="fw-semibold m-0 me-2">Upload from device</p>
							<span className="profile_btn"><input type="file" name="file" onChange={this.onChangejsonHandler} /></span>
						</div>
					</div>
					<ul className="gallery-multiselct-sec d-flex gap-4 flex-wrap mt-30px">
						{this.renderjsonGalleryImages()}
					</ul>
				</div>
			</div>

			{this.state.showUnlinkConfirm && (
				<div className="confirm-action show">
					<p>Are you sure you want to unlink this image from the gallery?</p>
					<a href="javascript://" onClick={() => this.confirmUnlink('yes')} className="btn">Yes</a>
					<a href="javascript://" onClick={() => this.confirmUnlink('no')} className="btn">No</a>
				</div>
			)}

			{this.state.showjsonUnlinkConfirm && (
				<div className="confirm-action show">
					<p>Are you sure you want to unlink this image from the gallery?</p>
					<a href="javascript://" onClick={() => this.confirmjsonUnlink('yes')} className="btn">Yes</a>
					<a href="javascript://" onClick={() => this.confirmjsonUnlink('no')} className="btn">No</a>
				</div>
			)}

			{this.state.showUsageWarning && (
				<div className="confirm-action show">
					<p>{this.state.imageUsageMessage}</p>
					<a href="javascript://" onClick={() => this.setState({ showUsageWarning: false, unlinkImage: null })} className="btn">OK</a>
				</div>
			)}
			</div>

		</div>
	</div>

    </div>
    );
  }
}


export default (withRouter(Add));